import styled, { createGlobalStyle } from 'styled-components'
import { MEDIA } from '../utils/'

// Media query
const { MOBILE } = MEDIA

export default createGlobalStyle`
    :root {
      /* Blue */
      --cobasi-blue: #009CA6;
      --cobasi-blue-light: rgba(30, 139, 152, 0.3);
      --cobasi-blue-light-2: #00C5DB;
      --cobasi-blue-light-3: #01B2C3;
      --cobasi-blue-light-4: #00A3B4;
      --cobasi-blue-light-6: #E0F8F9;
      --cobasi-blue-light-7: #0097BB;
      --cobasi-blue-light-8: #028BB7;
      --cobasi-blue-light-9: #00A6CE;
      --cobasi-blue-inactive: #7AD1DB;
      --cobasi-blue-inactive-alt: #007F8C;
      --eastern-blue: #12A3B4;
      --cobasi-primary: #01878E;
      --dark-sapphire: #18396d;
      --catalina-blue: #204c93;
      --deep-sea: #003383;
      --sapphire: #00255F;
      --cobasi-light-blue: #c8e5e8;
      --echo-blue: #99ABCD;
      --jade: #00B46A;
      --petanjo-blue: #118BB8;
      --pet-anjo-light-blue: #D2E1F4;
      --pet-anjo-dark-blue: #1F67C9;
      --pet-anjo-lighter-blue: #D8EEF6;
      --facebook-blue: #3C5A99;
      --schedule-light-blue: #DCF1F4;
      --schedule-blue: #007B88;
      --aqua-700: #14C3CC;
      --aqua-900: #0F9299;
      --sky-blue: #19F4FF;
      --navy-blue: #4066A2;
      --teal-blue: #05A3B4;
      --ice-blue: #F6FCFD;
      --tealish-blue: #1695A6;
      --dusty-turquoise: #43A4B4;
      --pale-blue: #9ED9DD;
      --pale-sky-blue: #B0E3F0;
      --caribbean-blue: #00B0C0;
      --caribbean-light-blue: #4AC8D6;
      --aqua-teal: #19A3B4;
      --lighter-aqua: #B3EDF0;

      /* Orange/Yellow */
      --cobasi-orange: #F27D00;
      --cobasi-orange-2: #E67500;
      --cobasi-orange-3: #FF8200;
      --cobasi-orange-light: rgba(242, 125, 0, 0.3);
      --orange-medium: #FF7E51;
      --orange-700: #FF8F1A;
      --dark-yellow: #EFB520;
      --star-yellow: #ffcc46;
      --golden-yellow: #CE9400;
      --tangerine-orange: #FF6500;
      --peach-beige: #FFDAB3;
      --soft-apricot: #E7A969;
      --pumpkin-orange: #F69E1A;
      --coral-orange: #FF7342;
      --coral-orange-light: #FFF2EE;
      --bronze-gold: #C80E3B;
      --golden-rod: #EFB529;

      /* Green */
      --success: #25B000;
      --success-pastel: #DAF2D4;
      --green-light: #DFF6F8;
      --whatsapp-green: #00E147;
      --mint-green: #23E147;
      --dark-mint-green: #26B11D;
      --teal-green: #1E8B98;

      /* Red */
      --red-700: #FF405B;
      --red-900: #CC3349;
      --reddish-brown: #E84C3C;
      --the-red: #FF0000;

      /* Pink */
      --mandy: #DA4453;
      --light-pink: #FCE2E7;
      --salmon: #F49B9B;
      --pale-pink: #FFF4F4;
      --coral-pink: #FFCFD6;

      /* Gray Tones */
      --the-white: #fff;
      --the-gray: #f8f9fa;
      --the-black: #000000;
      --the-rock: #525252;
      --gray-1: #111111;
      --gray-2: #222222;
      --gray-3: #333333;
      --gray-4: #444444;
      --gray-5: #555555;
      --gray-6: #666666;
      --gray-7: #777777;
      --gray-8: #888888;
      --gray-9: #999999;
      --platinum: #EEEEEE;
      --gallery: #EBEBEB;
      --mercury: #e1e4e1;
      --dark-gray: #d5d5d5;
      --alto-gray: #E0E0E0;
      --darker-gray: #c6c6c6;
      --rain-cloud: #bdbdbd;
      --light-gray: #b3b3b3;
      --silver-chalice: #9D9D9D;
      --dim-gray: #808080;
      --smoke: #757575;
      --silver: #DADADA;
      --bleached-silk: #f2f2f2;
      --neutral-gray: #EDEDED;
      --apricot-light: #FFFAF4;
      --apricot: #FAEAD8;
      --apricot-darken: #FAEAD0;
      --schedule-gray: #707070;
      --clean-gray: #FAECCA;
      --light-warning: #FDF8E9;
      --silver-gray: #CCCCCC;
      --steel-gray: #6D6D6D;
      --lighter-gray: #D8D8D8;
      --dark-slate: #223A3D;
      --light-slate: #BFBFBF;
      --pale-silver: #E1E1E1;
      --linen-white: #F5EEDE;
      --charcoal-gray: #4E4E4E;
      --neutral-darkish-gray: #d3d3d3;
      --midnight-black: #022222;
      --coal-black: #212121;
      --charcoal-gray-darker: #2E2E2E;

      /* Fonts */
      --primary-font: 'Montserrat', sans-serif;
      --secondary-font: 'Nunito', sans-serif;
    }

    *,
    *::after,
    *::before {
      margin: 0;
      padding: 0;
      box-sizing: inherit;
    }

    html {
      height: 100%;
      font-size: 62.5%;
      overflow:hidden;
      scroll-behavior:smooth;
    }

    body {
      position:relative;
      height: 100%;
      font-weight: 400;
      line-height: 1.7;
      color: var(--gray-3);
      background-color: var(--the-white);
      box-sizing: border-box;
      font-family: 'Montserrat';
      outline: none;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;

      & > #__next {
        min-height: 100%;
        display:flex;
        flex-direction:column;
      }
    }

    button {
      outline: none;
    }

    .Toastify__toast {
      font-size: 15px;
    }

    // hack de ajuste para placeholder de inputs apenas no IOS
    @supports (-webkit-touch-callout: none) {
      input::placeholder{
        line-height: 1;
      }
    }

  /* cyrillic-ext */
  @font-face {
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url('https://fonts.gstatic.com/s/nunito/v16/XRXV3I6Li01BKofIOOaBXso.woff2') format('woff2');
    unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;
  }
  /* cyrillic */
  @font-face {
    font-family: 'Nunito';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url('https://fonts.gstatic.com/s/nunito/v16/XRXV3I6Li01BKofIMeaBXso.woff2') format('woff2');
    unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
  }
  /* vietnamese */
  @font-face {
    font-family: 'Nunito';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url('https://fonts.gstatic.com/s/nunito/v16/XRXV3I6Li01BKofIOuaBXso.woff2') format('woff2');
    unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;
  }
  /* latin-ext */
  @font-face {
    font-family: 'Nunito';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url('https://fonts.gstatic.com/s/nunito/v16/XRXV3I6Li01BKofIO-aBXso.woff2') format('woff2');
    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
  }
  /* latin */
  @font-face {
    font-family: 'Nunito';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url('https://fonts.gstatic.com/s/nunito/v16/XRXV3I6Li01BKofINeaB.woff2') format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
  /* cyrillic-ext */
  @font-face {
    font-family: 'Nunito';
    font-style: normal;
    font-weight: 600;
    font-display: swap;
    src: url('https://fonts.gstatic.com/s/nunito/v16/XRXW3I6Li01BKofA6sKUbOvISTs.woff2') format('woff2');
    unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;
  }
  /* cyrillic */
  @font-face {
    font-family: 'Nunito';
    font-style: normal;
    font-weight: 600;
    font-display: swap;
    src: url('https://fonts.gstatic.com/s/nunito/v16/XRXW3I6Li01BKofA6sKUZevISTs.woff2') format('woff2');
    unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
  }
  /* vietnamese */
  @font-face {
    font-family: 'Nunito';
    font-style: normal;
    font-weight: 600;
    font-display: swap;
    src: url('https://fonts.gstatic.com/s/nunito/v16/XRXW3I6Li01BKofA6sKUbuvISTs.woff2') format('woff2');
    unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;
  }
  /* latin-ext */
  @font-face {
    font-family: 'Nunito';
    font-style: normal;
    font-weight: 600;
    font-display: swap;
    src: url('https://fonts.gstatic.com/s/nunito/v16/XRXW3I6Li01BKofA6sKUb-vISTs.woff2') format('woff2');
    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
  }
  /* latin */
  @font-face {
    font-family: 'Nunito';
    font-style: normal;
    font-weight: 600;
    font-display: swap;
    src: url('https://fonts.gstatic.com/s/nunito/v16/XRXW3I6Li01BKofA6sKUYevI.woff2') format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
  /* cyrillic-ext */
  @font-face {
    font-family: 'Nunito';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url('https://fonts.gstatic.com/s/nunito/v16/XRXW3I6Li01BKofAjsOUbOvISTs.woff2') format('woff2');
    unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;
  }
  /* cyrillic */
  @font-face {
    font-family: 'Nunito';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url('https://fonts.gstatic.com/s/nunito/v16/XRXW3I6Li01BKofAjsOUZevISTs.woff2') format('woff2');
    unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
  }
  /* vietnamese */
  @font-face {
    font-family: 'Nunito';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url('https://fonts.gstatic.com/s/nunito/v16/XRXW3I6Li01BKofAjsOUbuvISTs.woff2') format('woff2');
    unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;
  }
  /* latin-ext */
  @font-face {
    font-family: 'Nunito';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url('https://fonts.gstatic.com/s/nunito/v16/XRXW3I6Li01BKofAjsOUb-vISTs.woff2') format('woff2');
    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
  }
  /* latin */
  @font-face {
    font-family: 'Nunito';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url('https://fonts.gstatic.com/s/nunito/v16/XRXW3I6Li01BKofAjsOUYevI.woff2') format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
  /* cyrillic-ext */
  @font-face {
    font-family: 'Nunito';
    font-style: normal;
    font-weight: 800;
    font-display: swap;
    src: url('https://fonts.gstatic.com/s/nunito/v16/XRXW3I6Li01BKofAksCUbOvISTs.woff2') format('woff2');
    unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;
  }
  /* cyrillic */
  @font-face {
    font-family: 'Nunito';
    font-style: normal;
    font-weight: 800;
    font-display: swap;
    src: url('https://fonts.gstatic.com/s/nunito/v16/XRXW3I6Li01BKofAksCUZevISTs.woff2') format('woff2');
    unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
  }
  /* vietnamese */
  @font-face {
    font-family: 'Nunito';
    font-style: normal;
    font-weight: 800;
    font-display: swap;
    src: url('https://fonts.gstatic.com/s/nunito/v16/XRXW3I6Li01BKofAksCUbuvISTs.woff2') format('woff2');
    unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;
  }
  /* latin-ext */
  @font-face {
    font-family: 'Nunito';
    font-style: normal;
    font-weight: 800;
    font-display: swap;
    src: url('https://fonts.gstatic.com/s/nunito/v16/XRXW3I6Li01BKofAksCUb-vISTs.woff2') format('woff2');
    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
  }
  /* latin */
  @font-face {
    font-family: 'Nunito';
    font-style: normal;
    font-weight: 800;
    font-display: swap;
    src: url('https://fonts.gstatic.com/s/nunito/v16/XRXW3I6Li01BKofAksCUYevI.woff2') format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }

  .icon-location {
    color: var(--dusty-turquoise);
    font-size: 18px;
  }

  .selected-time {
    background: var(--cobasi-orange-2) !important;
    color: var(--the-white) !important;
    font-size: 13px !important;
  }

  .selectedCard {
    border: 1px solid #00A6C;
  }

  h1 {
    font-family: var(--primary-font);
    font-weight: 600;
    font-size: 24px;
    color: var(--gray-3);
  }

  input[type="text"]::placeholder {
    font-family: var(--primary-font) !important;
    color: var(--gray-7);
    font-size: 14px;
    font-weight: 400;
    line-height: 19.07px;
  }

  .secondaryBtn button:disabled {
    background-color: var(--soft-apricot);
    filter: unset;
  }

  .resumeContainer h2 {
    font-family: var(--primary-font);
    text-align: center;
    font-size: 21px;
    font-weight: 700;
    color: var(--gray-3);
    margin: 30px 0;
  }

  .ServiceButton {
    position: relative;
  }

  @media screen and (max-width: 575px) {
  //referente a página de perfil do pet (refatorar no futuro em componentes)

  .breedPadding {
  padding-right: 2em;
}

.datePicker {
  font-size: 1.5rem;
  height: 40px;
  width: 100%;
  border-radius: 5px;
  border: 1px solid var(--dark-gray);
  padding-left: 8px;
  outline: unset !important;
}

.displayNone {
  display: none;
}

.generalLabelSlider {
  width: 7%;
  display: inline-block;
}

.listsConfig {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
}

.radioConfig {
  width: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

.sliderSpace {
  margin-top: -12px;
}

.textRight {
  text-align: right !important;
}

.myPetImg {
  background-size: 60px;
  background-position: 17px 17px;
  width: auto !important;
  margin-top: 0 !important;
  height: 100% !important;
  border-radius: unset !important;
  vertical-align: middle !important;
}

.select__CustomBox-sc-14lqjja-0.vBAgM > label {
  display: block;
}

.petName > div {
  margin-top: 10px;
  margin-bottom: 20px;
}

h4 {
  font-family: var(--primary-font);
  font-weight: 600;
  font-size: 18px;
}

input[type="text"]:disabled {
  background: var(--the-white);
}

.generalLabelSlider {
  font-family: var(--primary-font);
  font-weight: 600;
  font-size: 18px;
  color: var(--gray-3);
}

.generalLabelSlider.textRight {
  position: relative;
  right: 0;
  float: right;
}

.weightSlider > div:after {
  background-color: var(--cobasi-blue-light-4) !important;
}

.birthNotKnow label {
  font-family: var(--primary-font);
  font-weight: 600;
  font-size: 14px;
  color: var(--gray-3);
}

.m-top-24 {
  margin-top: 24px;
}

@media (min-width: 1200px) {
  .header__ContainerArea-sc-1d3dopx-0.fdcMIi {
    background-color: var(--cobasi-blue);
  }
  .header__Area-sc-1d3dopx-1.bnHRBF {
    width: 1200px;
    margin: 0 auto;
  }
  .header__Area-sc-1d3dopx-1 .hjVysy img {
    width: 25%;
  }

  .header__Area-sc-1d3dopx-1 .jUnDkd .header__HeaderIcon-sc-1d3dopx-5.gVOhyw {
    width: 4rem;
    height: 4rem;
  }
  ._app__Container-ao1z73-0.gfUygK {
    width: 1200px;
    margin: 0 auto;
  }
  .search__Container-sc-1twbvpz-0.jEJXqg {
    width: 50%;
  }
  .search__Container-sc-1twbvpz-0.gAzHDT {
    width: 70%;
  }
  .search__SearchResultsBlock-sc-1twbvpz-4.jhspTh {
    width: 62%;
    transform: translateX(-50%);
    left: 50%;
  }
  .perfil-pet__Container-udxxkp-0.dYSjZR {
    max-width: 80%;
    margin: 0 auto;
  }
}

@media (min-width: 992px) and (max-width: 1199px) {
  .header__ContainerArea-sc-1d3dopx-0.fdcMIi {
    background-color: var(--cobasi-blue);
  }
  .header__Area-sc-1d3dopx-1.bnHRBF {
    width: 992px;
    margin: 0 auto;
  }
  .header__Area-sc-1d3dopx-1 .hjVysy img {
    width: 35%;
  }

  .header__Area-sc-1d3dopx-1 .jUnDkd .header__HeaderIcon-sc-1d3dopx-5.gVOhyw {
    width: 4rem;
    height: 4rem;
  }
  ._app__Container-ao1z73-0.gfUygK {
    width: 992px;
    margin: 0 auto;
  }
  .search__Container-sc-1twbvpz-0.jEJXqg {
    width: 50%;
  }
  .search__Container-sc-1twbvpz-0.gAzHDT {
    width: 70%;
  }
  .search__SearchResultsBlock-sc-1twbvpz-4.jhspTh {
    width: 62%;
    transform: translateX(-50%);
    left: 50%;
  }
  .perfil-pet__Container-udxxkp-0.dYSjZR {
    max-width: 80%;
    margin: 0 auto;
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  .header__ContainerArea-sc-1d3dopx-0.fdcMIi {
    background-color: var(--cobasi-blue);
  }
  .header__Area-sc-1d3dopx-1.bnHRBF {
    width: 768px;
    margin: 0 auto;
  }
  .header__Area-sc-1d3dopx-1 .hjVysy img {
    width: 45%;
  }

  .header__Area-sc-1d3dopx-1 .jUnDkd .header__HeaderIcon-sc-1d3dopx-5.gVOhyw {
    width: 4rem;
    height: 4rem;
  }
  ._app__Container-ao1z73-0.gfUygK {
    width: 768px;
    margin: 0 auto;
  }
  .search__Container-sc-1twbvpz-0.jEJXqg {
    width: 60%;
  }
  .search__Container-sc-1twbvpz-0.gAzHDT {
    width: 80%;
  }
  .search__SearchResultsBlock-sc-1twbvpz-4.jhspTh {
    width: 78%;
    transform: translateX(-50%);
    left: 50%;
  }
  .perfil-pet__Container-udxxkp-0.dYSjZR {
    max-width: 80%;
    margin: 0 auto;
  }
}
`
export const Container = styled.div`
  padding-top: ${(props) => props.paddingTop ?? 0}px;
  min-height: calc(100vh - 165px);
  @media screen and ${MOBILE} {
    min-height: calc(100vh - 88px);
  }
  @media screen and (min-width: 576px){
    padding-top: 88px;
  }
`

export const WrapperFormAndCard = styled.div`
  display: flex;
  width: 100%;
  max-width: 1100px;
  flex-direction: column-reverse;
  gap: 8px;
`
